import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';
export function WhatsInsideSection() {
  const contents = ['Plan día por día (7 días)', 'Checklist "Día 0" (preparación)', 'Lista de "Horas peligrosas"', 'Script de 20 minutos (para no escribirle)', '12 respuestas pre-escritas (si te escribe / si te provoca / si es logística)', 'Rutina noche (12 min) y mañana (10 min)', 'Hoja "Lo que fue vs lo que inventé"', 'Protocolo de recaídas (sin culpa)'];
  return <section className="bg-[#0D0D0D]" style={{
    paddingTop: 'var(--space-section)',
    paddingBottom: 'var(--space-section)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-200">
      <div className="max-w-2xl mx-auto" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-[#1A1816] rounded-2xl p-6 sm:p-8 md:p-10 border border-white/5" data-id="element-202">
          <div className="flex items-center gap-3 mb-8" data-id="element-203">
            <FileText className="text-[#A52422] w-6 h-6 shrink-0" data-id="element-204" />
            <h2 className="fluid-2xl font-bold text-white font-serif" data-id="element-205">
              Qué trae exactamente
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-206">
            {contents.map((item, index) => <div key={index} className="flex items-start gap-3 text-[#F5F0EB]/80 fluid-base" data-id="element-207">
                <span className="text-[#A52422] mt-1.5 text-xs shrink-0" data-id="element-208">
                  ●
                </span>
                <span data-id="element-209">{item}</span>
              </div>)}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-white/10 gap-6" data-id="element-210">
            <div className="text-center sm:text-left" data-id="element-211">
              <p className="text-[#9A948C] uppercase tracking-wider mb-1 fluid-xs" data-id="element-212">
                Formato
              </p>
              <p className="text-white fluid-base" data-id="element-213">
                PDF descargable + imprimibles
              </p>
            </div>
            <div className="text-center sm:text-left" data-id="element-214">
              <p className="text-[#9A948C] uppercase tracking-wider mb-1 fluid-xs" data-id="element-215">
                Tiempo diario
              </p>
              <p className="text-white fluid-base" data-id="element-216">10–20 minutos</p>
            </div>
            <div className="text-center" data-id="element-217">
              <p className="text-[#A52422] font-serif font-bold fluid-3xl" data-id="element-218">
                $6.36
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}